(function(){"use strict";var e;try{if(typeof document<"u"){var o=document.createElement("style");o.nonce=(e=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:e.content,o.appendChild(document.createTextNode("._accordionRoot_13og7_1,._accordionItem_13og7_7{display:flex;flex-direction:column;gap:var(--m)}._accordionHeader_13og7_13{width:100%}._accordionTrigger_13og7_17{border:none;outline:none;background:inherit;display:flex;align-items:center;justify-content:space-between;width:100%;gap:var(--s);color:var(--grey-800-33)}._accordionHeaderIcon_13og7_29{display:block;width:1rem;height:1rem}._accordionHeader_13og7_13[data-state=open] ._accordionHeaderIcon_13og7_29{transform:rotate(180deg)}._accordionContent_13og7_39{width:100%;box-sizing:border-box}._accordionContent_13og7_39[data-state=open]{animation:_slide-down_13og7_1 .4s ease-out,_slide-overflow_13og7_1 .4s forwards}._accordionContent_13og7_39[data-state=closed]{animation:_slide-up_13og7_1 .4s ease-in forwards,_slide-overflow_13og7_1 .4s forwards}@keyframes _slide-overflow_13og7_1{0%{overflow:hidden}99.99%{overflow:hidden}to{overflow:visible}}@keyframes _slide-down_13og7_1{0%{height:0}to{height:var(--radix-collapsible-content-height)}}@keyframes _slide-up_13og7_1{0%{height:var(--radix-collapsible-content-height)}to{height:0}}@media (prefers-reduced-motion){._accordionContent_13og7_39{transition:none;animation:none}}")),document.head.appendChild(o)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { jsx as i, jsxs as u } from "react/jsx-runtime";
import * as a from "@radix-ui/react-accordion";
import t from "react";
import { clsx as d } from "clsx";
import { I } from "./Icon-uSQ2CWO_.js";
const p = "_accordionRoot_13og7_1", H = "_accordionItem_13og7_7", R = "_accordionHeader_13og7_13", N = "_accordionTrigger_13og7_17", C = "_accordionHeaderIcon_13og7_29", w = "_accordionContent_13og7_39", e = {
  accordionRoot: p,
  accordionItem: H,
  accordionHeader: R,
  accordionTrigger: N,
  accordionHeaderIcon: C,
  accordionContent: w,
  "slide-down": "_slide-down_13og7_1",
  "slide-overflow": "_slide-overflow_13og7_1",
  "slide-up": "_slide-up_13og7_1"
}, l = t.forwardRef(
  function({ children: o, className: c, ...r }, n) {
    const m = {
      collapsible: !0
    };
    return /* @__PURE__ */ i(a.Root, { ref: n, ...m, ...r, className: d(e.accordionRoot, c), children: o });
  }
);
l.displayName = "AccordionRoot";
const _ = t.forwardRef(
  function({ className: o, children: c, ...r }, n) {
    return /* @__PURE__ */ i(a.Item, { ref: n, className: d(e.accordionItem, o), ...r, children: c });
  }
);
_.displayName = "AccordionItem";
const g = t.forwardRef(
  function({ className: o, children: c, ...r }, n) {
    return /* @__PURE__ */ i(a.Trigger, { ref: n, className: d(e.accordionTrigger, o), ...r, children: c });
  }
);
g.displayName = "AccordionTrigger";
const f = t.forwardRef(
  function({ className: o, children: c, showTrigger: r = !0, ...n }, m) {
    return /* @__PURE__ */ i(a.Header, { ref: m, className: d(e.accordionHeader, o), ...n, children: r ? /* @__PURE__ */ u(g, { className: d(e.accordionTrigger, o), children: [
      c,
      /* @__PURE__ */ i(I, { name: "chevron-line-down", className: e.accordionHeaderIcon })
    ] }) : c });
  }
);
f.displayName = "AccordionHeader";
const A = t.forwardRef(
  function({ className: o, children: c, ...r }, n) {
    return /* @__PURE__ */ i(a.Content, { ref: n, className: d(e.accordionContent, o), ...r, children: /* @__PURE__ */ i("div", { className: e.accordionContentContainer, children: c }) });
  }
);
A.displayName = "AccordionContent";
const h = Object.assign(l, {
  Content: A,
  Item: _,
  Header: f,
  Trigger: g
});
export {
  h as A
};
